module.exports = __webpack_public_path__ + "img/01.fde890d6.png";